/* eslint-disable no-unused-vars */
import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import fitCheckingServices from '../../../../../services/fit-checking.services';
import { branchActivityFormDefaultValues } from '../dto/branchActivity';
import BranchActivityForm from '../form/BranchActivityForm';

const BranchActivityModal = ({ open, handleClose, branchId }) => {
  const { watch, handleSubmit, reset } = useFormContext();
  const queryClient = useQueryClient();

  const { mutate: createActivity } =
    fitCheckingServices.useMutationCreateBranchActivity(
      () => {
        queryClient.invalidateQueries({
          queryKey: ['get-checking-branch-activities'],
          refetchType: 'all',
        });
        AlertSuccess('เพิ่มข้อมูลสำเร็จ');
        reset(branchActivityFormDefaultValues);
        handleClose();
      },
      (error) => {
        AlertSuccess(error);
      },
    );

  const { mutate: editActivity } =
    fitCheckingServices.useMutationUpdateBranchActivity(
      () => {
        queryClient.invalidateQueries({
          queryKey: ['get-checking-branch-activities'],
          refetchType: 'all',
        });
        AlertSuccess('แก้ไขข้อมูลสำเร็จ');
        reset(branchActivityFormDefaultValues);
        handleClose();
      },
      (error) => {
        AlertSuccess(error);
      },
    );

  const _HandleSubmit = handleSubmit((data) => {
    const activityData = {
      branchId: branchId,
      desctiption: data.desctiption,
      startDate: new Date(data.startDate),
      endDate: new Date(data.endDate),
      display: data.display,
    };

    if (watch('formType') === 'create') {
      createActivity(activityData);
    } else if (watch('formType') === 'edit') {
      editActivity({ id: data.id, data: activityData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create' ? 'เพิ่มกิจกรรมสาขา' : 'แก้ไขกิจกรรมสาขา'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <BranchActivityForm />
    </Modal>
  );
};

export default BranchActivityModal;
